import Guard from "vue-router-multiguard";
import { Middlewares } from "@/app/shared/services/app-router/middlewares";

export default [
    {
        path: "/register",
        name: "Registration",
        component: () => import("./views/registration"),
        beforeEnter: Guard([Middlewares.unAuthRequired]),
    },
    {
        path: "/payment-credentials",
        name: "RegistrationPayment",
        component: () => import("./views/payments"),
        beforeEnter: Guard([Middlewares.registrationNotComplete]),
    },
    {
        path: "/email-confirm",
        name: "RegValidateEmail",
        component: () => import("./views/validateEmail"),
        beforeEnter: Guard([Middlewares.userCredentionalsRequired]),
    },
    {
        path: "/check-requisites",
        name: "CheckRequisites",
        component: () => import("./views/checkRequisites"),
        beforeEnter: Guard([Middlewares.registrationNotComplete]),
    },
    {
        path: "/forgot-password",
        name: "ForgotPassword",
        component: () => import("./views/forgotPassword"),
    },
];
